import React, { createContext, useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { GetJsonBridge } from "../../services/backendServices";
import { STORAGE_KEYS } from "../../Util/key_helper";
// Create a context for JsonBridge Data 
export const JsonBridgeContext = createContext();
/*** JsonBridgeContextProvider: A provider component to manage and supply json bridge data*/
export const JsonBridgeContextProvider = ({ children }) => {
    const [isJsonBridgeDataLoading, setIsJsonBridgeDataLoading] = useState(false); // State to track loading status for json bridge data
    const [isJsonBridgeDataFetched, setIsJsonBridgeDataFetched] = useState(false); // State to track if json bridge data has been fetched
    const [jsonBridgeData, setJsonBridgeData] = useState([]); // State to store json bridge data
    const fetchJsonBridgeData = async ({ showToast = false } = {}) => {
        setIsJsonBridgeDataLoading(true);
        try {
            const res = await GetJsonBridge();
            if (res.status) {
                setJsonBridgeData(res.data);
                setIsJsonBridgeDataFetched(true);
                if (showToast) toast.success("Json Bridge data refreshed successfully");
            } else {
                if (showToast) toast.error("Failed to fetch JSON Bridge data");
            }
        } catch (e) {
            console.error("Error fetching json bridge data:", e);
            if (showToast) toast.error("Error while fetching JSON Bridge data");
        } finally {
            setIsJsonBridgeDataLoading(false);
        }
    };

    //function to add json bridge data 
    const addJsonBridge = (resData) => {
        const updatedData = { ...resData, og_is_connected: false, og_place_order: true };
        setJsonBridgeData(prevData => [...prevData, updatedData]);
    };
    const refreshJsonBridgeData = () => fetchJsonBridgeData({ showToast: true });

    // Function to update specific fields of a bridge in Json Bridge
    const updateJsonBridge = (json_bridge_id, updatedFields) => {
        setJsonBridgeData((prevData) =>
            prevData.map((item) =>
                item.json_bridge_id === json_bridge_id ? { ...item, ...updatedFields } : item
            )
        );
    };

    // Function to remove Json bridge Dtaa
    const removeJsonBridge = (json_bridge_id) => {
        setJsonBridgeData((prevData) => prevData.filter((item) => item.json_bridge_id !== json_bridge_id));
    };

    useEffect(() => {
        const handleLoginStatusChange = (event) => {
            // Check if the specific key changed
            if (event.key === STORAGE_KEYS.BROKER_PANEL_USER_IS_LOGGIN_IN) {
                // Reset JSON bridge data when login status changes
                setIsJsonBridgeDataFetched(false);
            }
        };
        // Listen for storage changes (cross-tab)
        window.addEventListener("storage", handleLoginStatusChange);
        return () => {
            window.removeEventListener("storage", handleLoginStatusChange);
        };
    }, []);

    return (
        // The JsonBridgeContext.Provider component provides state and functions to the children components
        <JsonBridgeContext.Provider value={{
            isJsonBridgeDataLoading, // State to track loading status for json bridge data
            isJsonBridgeDataFetched, // State to track if json bridge data has been fetched
            jsonBridgeData, // State to store json bridge data
            fetchJsonBridgeData,  // Function to fetch json bridge data
            refreshJsonBridgeData, // Function to refresh json bridge data
            addJsonBridge,         // Function to add json bridge data
            removeJsonBridge,     // Function to remove json bridge data
            updateJsonBridge,     // Function to update json bridge data
            setIsJsonBridgeDataFetched // Function to set the fetched status of json bridge data

        }}>
            {children}
        </JsonBridgeContext.Provider>
    );
};
// Custom hook to access JsonBridgeContext data
export const useJsonBridgeContext = () => {
    return useContext(JsonBridgeContext);
};